var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#F34F66",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 51.5655C23 54.0048 24.9498 56 27.3333 56H44.6667C47.0502 56 49 54.0048 49 51.5655V27.44C49 26.6447 48.3553 26 47.56 26H24.44C23.6447 26 23 26.6447 23 27.44V51.5655ZM28 35C28 34.4477 28.4477 34 29 34C29.5523 34 30 34.4477 30 35V48C30 48.5523 29.5523 49 29 49C28.4477 49 28 48.5523 28 48V35ZM42 35C42 34.4477 42.4477 34 43 34C43.5523 34 44 34.4477 44 35V48C44 48.5523 43.5523 49 43 49C42.4477 49 42 48.5523 42 48V35ZM37 35C37 34.4477 36.5523 34 36 34C35.4477 34 35 34.4477 35 35V48C35 48.5523 35.4477 49 36 49C36.5523 49 37 48.5523 37 48V35ZM53 22.24C53 21.4447 52.3553 20.8 51.56 20.8H45.3203C44.8118 20.8 44.341 20.5318 44.0816 20.0944L42.0724 16.7056C41.8131 16.2682 41.3423 16 40.8338 16H31.1663C30.6578 16 30.187 16.2682 29.9277 16.7056L27.9184 20.0944C27.659 20.5318 27.1882 20.8 26.6797 20.8H20.44C19.6447 20.8 19 21.4447 19 22.24V22.56C19 23.3553 19.6447 24 20.44 24H51.56C52.3553 24 53 23.3553 53 22.56V22.24Z",
    fill: "#F5314D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.507ceeda9c68b144771773b287240b70.svg";
export { ForwardRef as ReactComponent };